import React from 'react';

const serviceCards = [
  {
    id: 'seo',
    title: 'Search Engine Optimization',
    desc: 'Our SEO team brings quality traffic to your website and increases your rate of conversions. We focus on site health improvement and keyword research to rank your site. Our leading digital marketing company is an expert at building authority for your website with quality link building. Experts Communication aligns with user intent to make sure that the site works well in all aspects. Our professional team provides complete audits to identify areas for improvement.',
    icon: (
      <div className="dig-stack-icon-g">
        <svg width="34" height="34" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
          <circle cx="12" cy="12" r="10" />
          <path d="M12 8h4v4h-4z" />
          <path d="M12 12H8" />
        </svg>
        <div className="dig-stack-stars">
          <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2" /></svg>
          <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2" /></svg>
          <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2" /></svg>
        </div>
      </div>
    )
  },
  {
    id: 'smm',
    title: 'Social Media Marketing',
    desc: 'Get conversion-generating social media marketing services to advertise your brand on social media channels and increase your brand awareness. Our company wants to bring a rise in your engagement and rate of conversions. We work on platforms like Instagram, Facebook, LinkedIn, and TikTok. Experts Communication follows a complete process that includes strategic content creation and targeted audience analysis. We also perform content optimization and develop customized content calendars for the best results.',
    icon: (
      <div className="dig-stack-icon-wrap">
        <svg width="36" height="36" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
          <circle cx="18" cy="5" r="3" />
          <circle cx="6" cy="12" r="3" />
          <circle cx="18" cy="19" r="3" />
          <line x1="8.59" y1="13.51" x2="15.42" y2="17.49" />
          <line x1="15.41" y1="6.51" x2="8.59" y2="10.49" />
        </svg>
      </div>
    )
  },
  {
    id: 'web-design',
    title: 'Web Design',
    desc: 'Our company presents the best websites to drive user engagement and increase your conversion rates. Our digital marketing company in Karachi crafts custom web solutions that reflect your brand identity. We prioritize user-centric design so that your website delivers the best functionality and a compelling user experience. Our professional team conducts thorough usability assessments and implements top notch designs to provide the best look to your website.',
    icon: (
      <div className="dig-stack-icon-wrap">
        <svg width="36" height="36" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
          <polyline points="16 18 22 12 16 6" />
          <polyline points="8 6 2 12 8 18" />
        </svg>
      </div>
    )
  },
  {
    id: 'web-dev',
    title: 'Web Development',
    desc: 'We build strong and responsive websites to scale your brand. Experts Communication delivers the best performance and quality user experiences with our websites. Our team focuses on efficient coding practices and modern development frameworks so that your site operates efficiently and maintains optimal security standards. Our services are diverse and professional. We also offer custom web applications and e-commerce website development that integrate smoothly with your business systems. Our best digital marketing agency in Karachi crafts websites that can handle high traffic volumes and have a lightning-fast load time. Our professional team conducts complete testing and quality assurance processes to deliver bug-free and cross-platform compatible websites.',
    icon: (
      <div className="dig-stack-icon-wrap">
        <svg width="36" height="36" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
          <rect x="2" y="3" width="20" height="14" rx="2" ry="2" />
          <line x1="8" y1="21" x2="16" y2="21" />
          <line x1="12" y1="17" x2="12" y2="21" />
        </svg>
      </div>
    )
  },
  {
    id: 'ecom-dev',
    title: 'E Commerce Website Development',
    desc: 'Our e-commerce website development team creates quality online stores to maximize your sales potential and improve customer shopping experiences. We integrate inventory management systems and a secure payment gateway to maintain the trust of your customers. Our company builds custom e-commerce platforms with advanced features like product catalogs, shopping carts, and automated order processing. Our developers focus on the mobile responsiveness and conversion optimization of the website so that your online store captures sales across all devices. We consider all the security measures and performance optimization techniques to deliver safe and reliable e-commerce solutions for your brand.',
    icon: (
      <div className="dig-stack-icon-wrap">
        <svg width="36" height="36" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
          <circle cx="9" cy="21" r="1" />
          <circle cx="20" cy="21" r="1" />
          <path d="M1 1h4l2.68 13.39a2 2 0 0 0 2 1.61h9.72a2 2 0 0 0 2-1.61L23 6H6" />
        </svg>
      </div>
    )
  },
  {
    id: 'email-mkt',
    title: 'Email Marketing',
    desc: 'Our email marketing team creates targeted email campaigns to encourage leads and drive more revenue for your business. We create personalized content to make a strong connection with the reader. Our team uses automated workflow systems so that your messages reach the right audience at the optimal time. Our email marketers craft email sequences with high open rates, click-through rates, and conversion optimization. Our team implements complete A/B testing and performance analytics to deliver the best email strategies that maximize engagement and generate measurable ROI.',
    icon: (
      <div className="dig-stack-icon-wrap">
        <svg width="36" height="36" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
          <path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z" />
          <polyline points="22,6 12,13 2,6" />
        </svg>
      </div>
    )
  },
  {
    id: 'logo-design',
    title: 'Logo Design',
    desc: "Our leading digital marketing company creates memorable and impactful brand logos to build strong recognition in the marketplace. In our approach, we consider visual storytelling and brand psychology that help your logo communicate your company's values and resonate with your target audience. We bring unique logo concepts to maintain versatility across all marketing materials and digital platforms. Experts Communication prioritizes brand consistency and scalability to guarantee that your logo works well for different purposes and can be displayed on everything from business cards to billboards.",
    icon: (
      <div className="dig-stack-icon-wrap">
        <svg width="36" height="36" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
          <path d="M12 19l7-7 3 3-7 7-3-3z" />
          <path d="M18 13l-1.5-7.5L2 2l3.5 14.5L13 18l5-5z" />
          <path d="M2 2l7.586 7.586" />
          <circle cx="11" cy="11" r="2" />
        </svg>
      </div>
    )
  }
];

function DigitalMarketingServicesStack() {
  const scrollToForm = () => {
    const formEl = document.getElementById('digital-marketing-hero-form') || document.querySelector('.contact-section');
    if (formEl) {
      formEl.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section className="dig-stack-section">
      <div className="container dig-stack-container">
        {/* Left Column: Pinned Sticky Information */}
        <div className="dig-stack-left">
          <div className="dig-stack-sticky-wrap">
            <div className="dig-agency-header">
              <div className="dig-agency-red-bar"></div>
              <h2 className="dig-agency-title">
                <span className="text-red">Digital Marketing Services</span> In<br />
                Pakistan
              </h2>
            </div>

            <p className="dig-stack-desc">
              At Experts Communication, we create the best marketing plans that bring success to your brand on every digital platform. Our every service has an objective to multiply your returns and improve your online presence. Our internet marketing company helps businesses of every size, and we want to make your business a success story in the market.
            </p>

            <button className="btn-dig-primary dig-stack-btn" onClick={scrollToForm}>
              Get Started Now
            </button>
          </div>
        </div>

        {/* Right Column: Scroll-Overlapping Sticky Black Cards */}
        <div className="dig-stack-right">
          {serviceCards.map((card, index) => (
            <div 
              key={card.id} 
              className="dig-stack-card"
              style={{
                top: `${110 + index * 20}px`,
                zIndex: index + 1
              }}
            >
              {/* Icon Top Row */}
              <div className="dig-stack-card-icon">
                {card.icon}
              </div>

              {/* Card Title */}
              <h3 className="dig-stack-card-title">{card.title}</h3>

              {/* Card Description */}
              <p className="dig-stack-card-desc">{card.desc}</p>

              {/* Hover Action Bar */}
              <div className="dig-stack-card-action">
                <button className="dig-stack-learn-btn" onClick={scrollToForm}>
                  Learn more
                </button>
                <div className="dig-stack-action-icon" onClick={scrollToForm}>
                  <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
                    <line x1="7" y1="17" x2="17" y2="7" />
                    <polyline points="7 7 17 7 17 17" />
                  </svg>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}

export default DigitalMarketingServicesStack;
